export const getRechartsAxisDomains = <T>(
  data: T[],
  yKeys?: { key: keyof T }[]
): [string | number, string | number] => {
  let dataMin: number | null | string = null;
  let dataMax: number | null | string = null;

  data.forEach((d: any) => {
    yKeys?.forEach((yKey) => {
      const yValue = d[yKey.key];
      if (typeof yValue === 'number') {
        if (dataMin === null || yValue < dataMin) {
          dataMin = yValue;
        }
        if (dataMax === null || yValue > dataMax) {
          dataMax = yValue;
        }
      }
    });
  });

  if (dataMax !== null && dataMin !== null) {
    dataMin =
      dataMax - 0 > (dataMax - dataMin) * 50 && dataMin > 100 ? 'auto' : 0;
    dataMax = 'auto';
  } else {
    dataMin = 'auto';
    dataMax = 'auto';
  }

  return [dataMin, dataMax];
};
